// Progressive enhancement: nothing is hidden unless observation is available.
const instances=new WeakMap();
function mount(){
 const hero=document.querySelector('[data-lua-motion]');
 const main=hero?.closest('main');
 if(!main||instances.has(main)||!('IntersectionObserver' in window)||!Element.prototype.animate)return;
 const reduced=matchMedia('(prefers-reduced-motion: reduce)'),pending=new Set(),running=new Set();
 const selectors='h2,.section-top>p,.eyebrow,.detail-card,.video-card,.gallery,.product-description,.review-empty,.faq-list>details,.closing>.button,.benefit-strip>div,.multicolumn-list__item,.image-with-text__media,.rich-text__text';
 const eligible=el=>!el.closest('.lm-track,dialog,form,details p,.header')&&!el.closest('[data-flow]');
 function finish(el){el.dataset.flow='done';pending.delete(el)}
 function reveal(el,instant=false){
  if(!pending.has(el))return;
  observer.unobserve(el);finish(el);
  if(instant||reduced.matches)return;
  const words=el.querySelectorAll('.lf-word'),targets=words.length?[...words]:[el];
  targets.forEach((node,i)=>{
   const animation=node.animate([
    {opacity:0,transform:`translate3d(0,${words.length?'0.7em':'28px'},0)`,filter:`blur(${words.length?3:2}px)`},
    {opacity:1,transform:'translate3d(0,0,0)',filter:'blur(0px)'}
   ],{duration:words.length?850:900,delay:words.length?Math.min(i*48,380):Number(el.dataset.flowDelay||0),easing:'cubic-bezier(.16,1,.3,1)',fill:'backwards'});
   running.add(animation);animation.finished.catch(()=>{}).finally(()=>running.delete(animation));
  });
 }
 const observer=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting)reveal(entry.target)}),{rootMargin:'0px 0px -8% 0px',threshold:0});
 function prepare(scope=main){
  for(const el of scope.querySelectorAll(selectors)){
   if(el.dataset.flow||!eligible(el))continue;
   if(el.matches('h2')){
    const walker=document.createTreeWalker(el,NodeFilter.SHOW_TEXT),nodes=[];let node;
    while(node=walker.nextNode())nodes.push(node);
    for(const text of nodes){const fragment=document.createDocumentFragment();for(const token of text.textContent.split(/(\s+)/)){if(!token)continue;if(/^\s+$/.test(token)){fragment.append(document.createTextNode(token));continue}const word=document.createElement('span');word.className='lf-word';word.textContent=token;fragment.append(word)}text.replaceWith(fragment)}
   }
   const index=[...el.parentElement.children].indexOf(el);
   el.dataset.flowDelay=String(el.matches('.detail-card,.video-card,.multicolumn-list__item,.benefit-strip>div')?Math.min(index*110,330):80);
   // Already visible content and deep-linked sections remain immediately readable.
   if(reduced.matches||el.getBoundingClientRect().top<innerHeight*.92){el.dataset.flow='done';continue}
   el.dataset.flow='waiting';pending.add(el);observer.observe(el);
  }
 }
 function showAll(){if(reduced.matches){for(const el of [...pending])reveal(el,true);for(const animation of running)animation.cancel()}}
 function focus(event){for(const el of [...pending])if(el===event.target||el.contains(event.target))reveal(el,true)}
 reduced.addEventListener('change',showAll);main.addEventListener('focusin',focus);
 instances.set(main,{prepare});prepare();
}
mount();
document.addEventListener('shopify:section:load',()=>{const main=document.querySelector('[data-lua-motion]')?.closest('main');if(main&&instances.has(main))instances.get(main).prepare();else mount()});
